
import $ from 'jquery';
import domReady from '../utils/domready.js';
import '../utils/closest.js';

  function reflectStorageState(event) {
    var storage = event instanceof $.Event ? event.target : event;
    var teaser = storage.closest('.product-teaser');
    teaser && teaser.classList.toggle('product-teaser--closed', Boolean(storage.value));
  }

  function toggleStorageState(event) {
    event.preventDefault();
    var storage = this.nextElementSibling;
    var teaser = storage.closest('.product-teaser');
    teaser && (storage.value = !teaser.classList.contains('product-teaser--closed'));
  }

  $(document)
    .on('iron-localstorage-load', '.product-teaser__close-storage', reflectStorageState)
    .on('tap', '.product-teaser__close', toggleStorageState);

  domReady(function() {
    $('.product-teaser__close-storage').filter(function() { return this._loaded; }).map(function() { reflectStorageState(this)});
  });
